export const SET_UPLOAD_DATA = 'SET_UPLOAD_DATA'

const initialState = {
    uploadData: []
}

export default function (
    state = {
        ...initialState,
    },
    action = {}
){
    switch (action.type){
        case SET_UPLOAD_DATA:
            return {
                ...state,
                uploadData: action.data
            }
        default:
            return state
    }
}